module.exports = __webpack_public_path__ + "static/check.2c47fdda.svg";